import {playClassPool} from "./PlayClassPool";
import {ClassStep, createClassStepsFromJsonArray} from "../models/class-structure/generic/ClassStep";
import {PlayClass} from "../models/class-structure/generic/PlayClass";
import {playablePool} from "../../playable/utils/PlayablePool";
import {AbstractPlayableContent} from "../../playable/models/AbstractPlayableContent";
import {PlayClassProgress} from "../models/class-structure/generic/PlayClassProgress";
import {PianoSectionClass} from "../models/class-structure/piano/PianoSectionClass";
import {ClassType} from "../models/types/ClassType";
import {PlayableType} from "../../global/types/GlobalTypes";
import {ConsolidationClass} from "../models/class-structure/consolidation/ConsolidationClass";

export function createClassFromJson(jsonClass: any) {
  if (playClassPool.exists(jsonClass.id)) {
    return playClassPool.get(jsonClass.id);
  }

  const steps = createClassStepsFromJsonArray(jsonClass.steps);
  const requiredClasses = jsonClass.required_classes.map((requiredClass: any) => {
    // Required classes must have been created before
    return playClassPool.get(requiredClass.id);
  });
  const containedClasses = jsonClass.contained_classes.map((containedClass: any) => {
    return createClassFromJson(containedClass)
  });

  const progress = new PlayClassProgress(jsonClass.progress.max_step_id ?? -1, jsonClass.progress.progress);
  const playableType: PlayableType = (jsonClass.type === 'CONSOLIDATION' && jsonClass.playable_type !== 'version') ? 'list' : jsonClass.playable_type; // TODO: Find a better way
  const playableContent = playablePool.get(playableType, jsonClass.playable_id, jsonClass.playable_index ?? -1) as AbstractPlayableContent;

  const playClass = createValidPlayClassDependingOnType(jsonClass, playableContent, requiredClasses, containedClasses, steps, progress)
  playClassPool.push(playClass);

  return playClass;
}

/* eslint-disable no-fallthrough */
function createValidPlayClassDependingOnType(jsonClass: any, playableContent: AbstractPlayableContent, requiredClasses: PlayClass[], containedClasses: PlayClass[], steps: ClassStep[], progress: PlayClassProgress): PlayClass {
  // noinspection FallThroughInSwitchStatementJS
  switch (jsonClass.type as ClassType) {
    case "CONSOLIDATION":
      return new ConsolidationClass(jsonClass.id, jsonClass.type, playableContent, requiredClasses, containedClasses, steps, jsonClass.hasDemo, progress)
    case "PIANO_BOTH":
      if (jsonClass.playable_type === 'section') {
        return new PianoSectionClass(jsonClass.id, jsonClass.type, playableContent, requiredClasses, containedClasses, steps, jsonClass.hasDemo, progress)
      }
    case "SING":
    case "PIANO_LEFT":
    case "PIANO_RIGHT":
    default:
      return new PlayClass(jsonClass.id, jsonClass.type, playableContent, requiredClasses, containedClasses, steps, jsonClass.hasDemo, progress);
  }
}
/* eslint-enable no-fallthrough */

export function updateClassProgressFromJson(jsonClass: any) {
  const playClass = playClassPool.get(jsonClass.id)
  playClass.progress.maxStepId = jsonClass.progress.max_step_id ?? -1
  playClass.progress.total = jsonClass.progress.progress;

  jsonClass.contained_classes.map((containedClass: any) => {
    return updateClassProgressFromJson(containedClass)
  });
}
